/**
 * OVERRIDE Search.jsx
 */

import Search from '../../../../components/Search/Search';

export default Search;